import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import NotificationListItem from "../NotificationListItem";
import { Collection, CollectionStage, CollectionState, UserMetadata } from "../../types";
import Button from "../Button";
import { InputField } from "../InputField";
import { Routes } from "../../constants";
import { useAuth } from "../../contexts/AuthContext";
import { useApi } from "../../contexts/ApiContext";

type Props = {
   collections: any[];
};

const SearchList = React.memo(({ collections }: Props) => {
   const { push } = useHistory();

   const editCollection = (collection: any) => {
      if (!collection.state)push(`${Routes.MANAGE_COLLECTION}/${collection.id}`);
      else push(`${Routes.MANAGE_DRAFT}/${collection.id}`);
   };

   return (
      <div className="flex flex-col">
         {
            collections?.map((collection: any) => (
               <div
                  key={collection.id}
                  onClick={() => editCollection(collection)}
                  className="border-2 rounded-md bg-gray-900 border-gray-800 md:shadow-lg p-4 flex flex-row mb-4 justify-between cursor-pointer"
               >
                  <h4 className="uppercase font-bold text-xl">{collection.name}</h4>
               </div>
            ))
         }
         {
            collections?.length < 1 && 
            <div className="border-2 rounded-md bg-gray-900 border-gray-800 md:shadow-lg p-4 flex flex-row mb-4 justify-between cursor-pointer">
               <h4>Searching...</h4>
            </div>
         }

      </div>
   );
});

export default SearchList;
